import React from 'react';
import { ArrowRight, LogIn } from 'lucide-react';
import { Button } from '../ui/Button';
import { SectionLabel } from './SectionLabel';
import { HeroSticker } from './HeroSticker';
import { CMYKMark } from './CMYKMark';

interface Props {
  onPrimary: () => void;
  onSecondary: () => void;
}

export function HeroBlock({ onPrimary, onSecondary }: Props) {
  return (
    <section className="relative bt-paper-grain overflow-hidden">
      <CMYKMark className="absolute top-6 right-6 opacity-30 hidden md:block" />
      <CMYKMark className="absolute bottom-8 left-6 opacity-25 hidden md:block" />

      <div className="max-w-shell mx-auto px-4 md:px-6 py-14 md:py-20 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <div className="order-2 md:order-1">
          <SectionLabel tone="green">Álbum Copa 2026</SectionLabel>
          <h1 className="font-display font-extrabold text-ink-900 mt-4 text-[40px] md:text-[56px] leading-[1.05] tracking-[-0.025em]">
            Seu álbum,<br />
            <span className="text-green-700">suas trocas</span>,<br />
            sua galera.
          </h1>
          <p className="font-body text-ink-700 text-[17px] md:text-[18px] leading-relaxed mt-6 max-w-md">
            Marca as figurinhas que você tem, vê quais faltam e descobre na hora com qual amigo dá pra
            trocar. Sem planilha. Sem confusão. Bora.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button
              variant="primary"
              size="lg"
              icon={ArrowRight}
              iconRight={undefined}
              onClick={onPrimary}
            >
              Bora começar
            </Button>
            <Button variant="secondary" size="lg" icon={LogIn} onClick={onSecondary}>
              Já tenho conta
            </Button>
          </div>
          <p className="mt-5 text-caption text-ink-500">
            Grátis · Sem cadastro chato
          </p>
        </div>

        <div className="order-1 md:order-2 flex justify-center md:justify-end">
          <HeroSticker tilt={-4} />
        </div>
      </div>
    </section>
  );
}
